import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { ReactComponent as Cone } from "../../../Svgs/ConeLogistico/cone_logistico.svg";
import { useEffect } from 'react';
import axios from "axios";
import BasePage from '../../../Components/Base/BasePage';
import { ConeDeRisco } from '../../../Models/Paineis/ConeDeRisco/ConeDeRisco';
import ConeLogisticoDetalheViagemPopup from './ConeLogisticoDetalheViagemPopup';
import { ConeLogisticoConfiguracao } from '../../../Models/Paineis/ConeLogistico/ConeLogisticoConfiguracao';
import { ReactComponent as Programadas } from "../../../Svgs/ConeLogistico/topo_programadas.svg";
import { ReactComponent as EmViagem } from "../../../Svgs/ConeLogistico/topo_em_viagem.svg";
import { ReactComponent as Finalizadas } from "../../../Svgs/ConeLogistico/topo_finalizadas.svg";
import { ReactComponent as Automatico } from "../../../Svgs/ConeLogistico/valor_automatico.svg";
import { ReactComponent as Assistido } from "../../../Svgs/ConeLogistico/valor_assistido.svg";
import { ReactComponent as Sucesso } from "../../../Svgs/ConeLogistico/porcentagem_sucesso.svg";
import { ReactComponent as SemNc } from "../../../Svgs/ConeLogistico/porcentagem_sem_nc.svg";
import { ReactComponent as Tratativas } from "../../../Svgs/ConeLogistico/porcentagem_tratativas.svg";
import { ReactComponent as Eventos } from "../../../Svgs/ConeLogistico/porcentagem_eventos.svg";
let firstLoad: boolean = false;

const ConeLogisticoPage = (props: any) =>
{
  const [isOpen, setIsOpen] = useState(false);
  const [currentKey, setCurrentKey] = useState<string>('');
  const [dados, setDados] = useState<any>(new ConeDeRisco());
  const [logotipo, setLogotipo] = useState('');
  const [coneConfiguracao, setConeConfiguracao] = useState<any>(new ConeLogisticoConfiguracao());
  const setFirstLoad = (value: boolean) => firstLoad =  value;
  const [detalheIds, setDetalheIds] = useState('');
  const [usarRegraId, setUsarRegraId] = useState<boolean>(false);


  useEffect(() => {
    const inicializa = async () => inicializaAsync();
    inicializa();
  }, []);

  async function inicializaAsync() {
    await loadStyleCone();
    await carregaDadosConeAsync();
  }

  async function loadStyleCone() {
      let page = document.getElementById("main-height");
      if (page!=null) {
        page.setAttribute('style', 'background-color:#FFF !important');
      }
      
      let response: any = await axios.get(`coneLogisticoConfiguracao`);
      if (response.data != null && response.data != "") {
        setConeConfiguracao(response.data);
       
        //if (page!=null && (coneConfiguracao.cor_fundo??'') != '')
        setConfiguracaoPagina();

          
        for (const [key, value] of Object.entries(response.data)) {
          coneConfiguracao[key] = value;
        }

        if (coneConfiguracao.logotipo!=null)
        {
          setLogotipo(`${axios.defaults.baseURL}../files/${coneConfiguracao.logotipo}`)
        }
        else
        {
          setLogotipo(`${axios.defaults.baseURL}../KronaMaxxiReduzida.png`)
        }

        setColorConeConfiguracao();
      }
  }

  function setConfiguracaoPagina() {
    setTimeout( () =>  {
    //alert(1);
      let centralPage = document.getElementsByClassName("central-page")
      for (let index = 0; index < centralPage.length; index++) {
        centralPage[index]?.setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
      }

      //document.getElementsByClassName("central-page")[1]?.setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
      document.getElementById("main-height")?.setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
      document.getElementsByTagName("body")[0].setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
    }, 1000);
  }
    
  function setColorConeConfiguracao()
  {
      for (const [key, value] of Object.entries(coneConfiguracao)) {
          if (value == '' || value == null)
          {
              continue;
          }
          
          let colorClass = `area_${key}`;
          let elements = document.getElementsByClassName(colorClass) as HTMLCollectionOf<HTMLElement>;
          if (elements.length == 0)
          {
              elements = document.getElementsByClassName(key) as HTMLCollectionOf<HTMLElement>;
              if (elements.length > 0) {
                for (let index = 0; index < elements.length; index++) {
                  elements[index].innerHTML = `${value}`;
                }
              }
              
              continue;
          }

          Array.prototype.forEach.call(elements,
              function(element: any) {
                setColor(key, element, value);
          });
      }
  }

  function setColor(key: string, element: any, value: {}) {
      if (key == 'cor_fonte_titulo') {
          element.style['color'] = value;
      }

      else if (key == 'cor_fundo') {
          element.style['background-color'] = value;
      }
      else {
          element.style['fill'] = value;
      }
  }

  async function carregaDadosConeAsync() {  
    let response = await axios.get('coneLogistico');
    setDados(response.data);
    // for (const [key, value] of Object.entries(response.data)) {
    //   dados[key] = value;
    // }

    carregaEventos(response.data);
  }

  function carregaEventos(coneDados: any) {
    coneDados.forEach((element:any) => {
      
      let key = `camada_${element.id}`;
      let value = element.quantidade;
      //let label = element.descricao;
      let ids = element.ids;
    // for (const [key, value] of Object.entries(coneDados)) {
      if ((element.id ?? '') == '' ||
        (document.getElementsByClassName(key).length == 0 && document.getElementsByName(key).length == 0)) {
        return;
      }

      var quantidades = document.querySelectorAll(`.label.${key}`);
      Array.prototype.forEach.call(quantidades, function (el) {
        el.innerHTML = value as string;
      });

      // var labels = document.querySelectorAll(`text.${key}`);
      // labels[0].innerHTML = label as string;

      //if (!firstLoad) {
        var botoes = document.getElementsByClassName(key);
        Array.prototype.forEach.call(botoes, function (el) {
          el.removeEventListener('click', () => abrePopupAsync(key, ids, element.usar_regra_id));
          el.addEventListener('click', () => abrePopupAsync(key, ids, element.usar_regra_id));
        });
      //}
    });

    setFirstLoad(true);
  }

  async function abrePopupAsync(key: string, ids: string, usar_regra_id: boolean = false) 
  {
    if (isOpen) {
      return;
    }

    document.body.style.cursor = "wait";
    setDetalheIds(ids);
    setUsarRegraId(usar_regra_id);
    setCurrentKey(key);
    setIsOpen(true);
  }

  function closePopup() {
    setCurrentKey('');
    setIsOpen(false);
  }

  function getValueOrDefault(value: string, defaultValue: string)
  {
    if (value == null || value == '')
    {
      return defaultValue;
    }

    return value;
  }
  
  return (
    <div className="area_cor_fundo">
      <BasePage recursiveEvent={carregaDadosConeAsync}>
        
        <div style={{ left: '-15px', position: 'relative' }}>

          <div className="row col-12 justify-content-center">
            <div id="top-area" className="col-12 justify-content-center">
              <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 justify-content-center">
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6"><Programadas /></div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6"><EmViagem /></div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6"><Finalizadas /></div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <img style={{ width: '100%' }} src={logotipo} />
                </div>
              </div>

              <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center justify-content-center align-items-end">
                <div id="center-area" className="row col-xl-7 col-lg-10 col-md-12 col-sm-12 col-12">
                  <h6><strong className="col-12 chart-title cor_fonte_titulo">Gerenciamento de Risco Logístico</strong></h6>
                  <Cone />
                </div>
                
                
                <div className="row col-xl-4 col-lg-2 col-md-12 col-sm-10 col-10 justify-content-center align-items-end" style={{ marginBottom: '40px' }}>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4" id="area-automatico"><Automatico /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand " id="area-assistido"><Assistido /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-sucessos"><Sucesso /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-sem-ncs"><SemNc /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-tratativas"><Tratativas /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-eventos"><Eventos /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BasePage>

      {isOpen ? <ConeLogisticoDetalheViagemPopup isOpen={isOpen} onClose={closePopup} ids={detalheIds} dados={dados} usarRegraId={usarRegraId} /> : ''}
    </div>
  );
}

export default ConeLogisticoPage;

